<template>
  <div id="DocumentLimitTransactionSpecialTerms" class="sun not-full">
    <div class="title">특약사항</div>
    <div class="content">
      <p>1. 다음 각 항목에 해당하는 경우 별도의 통지 없이 기한의 이익을 상실한다.</p>
      <p class="indent">가) 사업자 폐업이나 변경시 기한의 이익을 상실한다.</p><br />
      <p class="indent">나) 고객이 사전 동의 없이 카드매출, ㈜우아한형제들 매출이 5영업일 이상
      발생되지 않을 때 기한의 이익을 상실한다.</p><br />
      <p class="indent">다) 제신고 된 카드사, ㈜우아한형제들 입금 계좌를 동의 없이 변경했을 시
      기한의 이익을 상실한다.</p><br />
      <p class="indent">라) 제신고 된 계좌에 입금된 카드매출, ㈜우아한형제들 매출금액을 동의 없이
      출금 했을 시 기한의 이익을 상실한다.
      <br />이경우, 제신고 된 계좌에 대해 출금제한(락기능)을 고객의 동의 없이 설정할수 있다.
      </p><br />
      <p class="indent">마) 대출 채권 상환을 위한 일일 카드매출, ㈜우아한형제들 매출대금 입금액의
      최대 10%는 절대 중도인출이 불가능하며 채무자는 이의를 제기할 수 없다.</p><br />
      <p class="indent">바) 위 내용을 위반하여 기한의 이익이 상실할 경우 카드매출, ㈜우아한형제들
      매출대금 입금액의 상환 비율을 '㈜펀다'에서 조정할 수 있으며,
      채무자는 이의를 제기할 수 없다.</p><br /><br />

      <p>2. 다음 각 항목에 해당하는 경우 모집된 금액은 자동으로 취소가 된다.</p>
      <p class="indent">가) 대출 신청 이후, 특약 1호를 위반하는 사유가 확인된 경우</p><br /><br />
    </div>
  </div>
</template>

<script>
export default {
  name: 'DocumentLimitTransactionSpecialTerms',
  props: ['loan'],
  data: function () {
    return {}
  },
  computed: {},
  created() {},
  destroyed() {},
  methods: {},
}
</script>

<style lang="scss" scoped>
#DocumentLimitTransactionSpecialTerms {
  padding-top: 25px;
  padding-bottom: 25px;
  background-color: #f4faff;
  .title {
    font-weight: 600;
    font-size: 16px;
  }
  .description {
    margin-top: 13px;
  }
  .content {
    font-size: 16px;
    line-height: 1.5;
    margin-top: 10px;
  }
  .indent {
    margin-left: 15px;
  }
}
</style>
